import React from 'react';
import { Search } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { ServiceListFiltersProps } from './ServiceListFilters.props';
import { FiltersContainer, SearchField } from './ServiceListFilters.styles';

export const ServiceListFilters: React.FC<ServiceListFiltersProps> = ({
  searchQuery,
  onSearchChange,
}) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <FiltersContainer>
      <SearchField
        placeholder="Search by ID, client, location..."
        value={searchQuery}
        onChange={handleSearchChange}
        size="small"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
        data-testid="search-input"
      />
    </FiltersContainer>
  );
};
